import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import CommonAlert from "../common/Commonalert";
import { http } from "../helper";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";
const MODULE = "manage_settings";

const SiteSettings = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [copyright_txt, setCopyright_Txt] = useState([]);
  const [minimum_orderamt, setMinimum_Orderamt] = useState([]);
  const [credit_limit, setCredit_Limit] = useState([]);
  const [discountOption, setDiscountOption] = useState(0);
  const [favouriteSettings, setFavouriteSettings] = useState(true);
  const [requestLimit, setRequestLimit] = useState(0);
  const [errormsg, setErrormsg] = useState({});
  const [errmessage, setErrMessage] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [masterLoginDisplayPrice, setMasterLoginDisplayPrice] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_settings")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    var loginDetails = {};
    if (window.sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(window.sessionStorage.getItem("authData"));
    }
    setIsLoading(true);
    let URL = BaseUrl + "admin/settings";
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        if (response.data.success === true) {
          setCopyright_Txt(responseData[0].copyrightText);
          setMinimum_Orderamt(responseData[0].minimumOrderAmount);
          setCredit_Limit(responseData[0].creditLimitPay);
          setDiscountOption(responseData[0].Discountpercent);
          setFavouriteSettings(
            responseData[0].favouriteSettings === true ||
              responseData[0].favouriteSettings === 1 ||
              responseData[0].favouriteSettings === "1" ||
              responseData[0].favouriteSettings === "true",
          );
          setRequestLimit(responseData[0].requestProductAccessLimit);
          setMasterLoginDisplayPrice(responseData[0].masterLoginDisplayPrice);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  const btnsubmit = (e) => {
    e.preventDefault();
    if (isReadOnly) return;
    var loginDetails = {};
    if (window.sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(window.sessionStorage.getItem("authData"));
    }
    const isValid = formvalidation();
    if (isValid) {
      let payload = {
        copyrightText: copyright_txt.trim(),
        minimumOrderAmount: minimum_orderamt,
        creditLimitPay: credit_limit,
        Discountpercent: discountOption,
        favouriteSettings: favouriteSettings,
        requestProductAccessLimit: requestLimit,
        masterLoginDisplayPrice: masterLoginDisplayPrice,
      };
      let URL = BaseUrl + "admin/settings";
      http
        .post(URL, payload)
        .then(async (response) => {
          if (response.data.success === true) {
            setAlertPopup(true);
            setAlertMessage(t("site_settings_updated_successfully_txt"));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const formvalidation = () => {
    const errmessage = {};
    const errmsg = {};
    let isValid = true;
    if (copyright_txt == "") {
      errmessage.copyrighttxterr = t("copyright_text_required_txt");
      errmsg.cpytxt = true;
      isValid = false;
    }
    if (minimum_orderamt == "") {
      errmessage.minimumorder_amterr = t("minimum_order_amount_required_txt");
      errmsg.moamt = true;
      isValid = false;
    }
    if (credit_limit == "") {
      errmessage.credit_limiterr = t("credit_limit_required_txt");
      errmsg.crelim = true;
      isValid = false;
    }
    if (isValid) {
      errmessage.copyrighttxterr = "";
      errmessage.minimumorder_amterr = "";
      errmessage.credit_limiterr = "";
      errmsg.cpytxt = false;
      errmsg.moamt = false;
      errmsg.crelim = false;
      setErrMessage(errmessage);
      return isValid;
    } else {
      setErrMessage(errmessage);
      setErrormsg(errmsg);
      return isValid;
    }
  };

  const handleOnChange = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.name === "copyright_txt") {
      setCopyright_Txt(e.target.value);
      if (errmessage.copyrighttxterr != "") {
        errormsg.cpytxt = false;
      }
      setErrormsg(errormsg);
    }
    if (e.target.name === "minimum_orderamt") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setMinimum_Orderamt(e.target.value);
      }
      if (errmessage.minimumorder_amterr != "") {
        errormsg.moamt = false;
      }
      setErrormsg(errormsg);
    }
    if (e.target.name === "credit_limit") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setCredit_Limit(e.target.value);
      }
      if (errmessage.credit_limiterr != "") {
        errormsg.crelim = false;
      }
      setErrormsg(errormsg);
    }
    if (e.target.name === "discountOption") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setDiscountOption(e.target.value);
      }
    }
    if (e.target.name === "favouriteSettings") {
      setFavouriteSettings(e.target.checked);
    }
    if (e.target.name === "request_limit") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setRequestLimit(e.target.value);
      }
    }
    if (e.target.name === "masterLoginDisplayPrice") {
      setMasterLoginDisplayPrice(e.target.value);
    }
    setAlertPopup(false);
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <CommonAlert
          title={t("alert_txt")}
          message={alertMessage}
          onClose={() => setAlertPopup(false)}
        />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">{t("site_setting_txt")}</h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
              <div className="form-field freeproduct-fieldset sitesettings-fieldset form-container-xs">
                <form className="client-detail-form">
                  <div className="input-field col-1">
                    <label htmlFor="name">{t("copyright_text_txt")}</label>
                    <input
                      type="text"
                      name="copyright_txt"
                      value={copyright_txt}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                    {errormsg.cpytxt && (
                      <div style={{ color: "red" }}>
                        {errmessage.copyrighttxterr}
                      </div>
                    )}
                  </div>
                  <div className="input-field col-1">
                    <label htmlFor="name">{t("minimum_order_amount_txt")}</label>
                    <input
                      type="text"
                      name="minimum_orderamt"
                      value={minimum_orderamt}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                    {errormsg.moamt && (
                      <div style={{ color: "red" }}>
                        {errmessage.minimumorder_amterr}
                      </div>
                    )}
                  </div>
                  <div className="input-field col-1">
                    <label htmlFor="name">{t("default_credit_limit_txt")}</label>
                    <input
                      type="text"
                      name="credit_limit"
                      value={credit_limit}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                    {errormsg.crelim && (
                      <div style={{ color: "red" }}>
                        {errmessage.credit_limiterr}
                      </div>
                    )}
                  </div>
                  <div className="input-field col-1">
                    <label htmlFor="name">
                      {t("discount_percentage_all_categories_products_txt")}
                    </label>
                    <input
                      type="text"
                      name="discountOption"
                      value={discountOption}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                  </div>
                  <div className="input-field col-1">
                    <label htmlFor="name">
                      {t("display_inactive_products_favourite_settings_txt")}
                    </label>
                    <div className="switch-button">
                      <input
                        type="checkbox"
                        className="checkbox"
                        name="favouriteSettings"
                        id="favouriteSettings"
                        checked={favouriteSettings}
                        onChange={(e) => {
                          if (isReadOnly) return;
                          handleOnChange(e);
                        }}
                      />
                      <div className="knobs">
                        <span></span>
                      </div>
                      <div className="layer"></div>
                    </div>
                  </div>
                  <div className="input-field col-1">
                    <label htmlFor="masterLoginDisplayPrice">
                      {t("display_price_for_master_login_txt")}
                    </label>
                    <input
                      type="text"
                      name="masterLoginDisplayPrice"
                      id="masterLoginDisplayPrice"
                      value={masterLoginDisplayPrice}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                  </div>
                  <div className="input-field col-1">
                    <label htmlFor="request_limit">
                      {t("request_product_access_limit_txt")}
                    </label>
                    <input
                      type="text"
                      name="request_limit"
                      id="request_limit"
                      value={requestLimit}
                      onChange={handleOnChange}
                      readOnly={isReadOnly}
                    />
                  </div>
                  <div className="btnfield">
                    {!isReadOnly && (
                      <button
                        title={t("save_section_txt")}
                        type="submit"
                        name="btnsubmit"
                        onClick={btnsubmit}
                      >
                        {t("save_section_txt")}
                      </button>
                    )}
                  </div>
                </form>
              </div>
              )}
            </div>
          </div>
          <Footer />
        </section>
      </div>
    </section>
  );
};
export default SiteSettings;
